import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Alert, Col, Row} from "reactstrap";
import LazyImage from "../../../components/media/images/LazyImage";
import PolyUtil from "../../../util/PolyUtil";
import {Field, reduxForm} from "redux-form";
import {CheckBoxField, DateField, InputField} from "../../../validation/ReduxFormInput";
import {FormAsyncButton} from "../../../components/controls/buttons/AsyncButton";
import {handleEditListing} from "../actions/owner";
import {hideModal} from "../../../store/actions/display";

class EditListingForm extends Component {
    render() {
        const {error, handleSubmit, _handleEditListing, initialValues, invalid, submitting, display_address, city, state, propId, listingId} = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit((data) => _handleEditListing(data, propId, listingId))}>
                    <Row>
                        <Col>
                            <LazyImage style={{borderRadius: '10px'}} src={PolyUtil.buildStreetViewUrl(600, 300, display_address + "," + city + "," + state)}/>
                        </Col>
                    </Row>
                    <h5 className="mt-2 text-center">{display_address}</h5>
                    <hr/>
                    <Row>
                        <Col xs={12} md={6}>
                            <Field name="rent" addon="$" label="Rent" component={InputField} type="number"/>
                        </Col>
                        <Col xs={12} md={6}>
                            <Field name="security_deposit" addon="$" label="Security Deposit" component={InputField} type="number"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6}>
                            <Field name="lease_length" label="Lease Length" addon="Months" addon_end min={1} component={InputField} type="number"/>
                        </Col>
                        <Col xs={12} md={6}>
                            <Field name="lease_start" label="Lease Start Date" component={DateField}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Field name="description" label="Description" component={InputField} type="textarea"/>
                        </Col>
                    </Row>
                    <div className="center">
                        <Field name="public" label="Publicly list this property" component={CheckBoxField} props={{defaultChecked: initialValues.public, className: "mb-2"}}/>
                        <FormAsyncButton block
                                         acting={submitting}
                                         color="success"
                                         type="submit"
                                         disabled={invalid || submitting}>Save</FormAsyncButton>
                    </div>
                    {
                        error &&
                        <div className="center" style={{marginTop: '5px'}}>
                            <Alert color="danger">
                                {error}
                            </Alert>
                        </div>
                    }
                </form>
            </div>
        );
    }
}

EditListingForm.propTypes = {
    propId: PropTypes.number.isRequired,
};

const validate = values => {
    const errors = {};

    !values.rent && (errors.rent = 'Required');
    !values.security_deposit && (errors.security_deposit = 'Required');
    !values.lease_length && (errors.lease_length = 'Required');
    !values.lease_start && (errors.lease_start = 'Required');

    (values.rent && values.rent < 0) && (errors.rent = "Can't be less than 0");
    (values.security_deposit && values.security_deposit < 0) && (errors.security_deposit = "Can't be less than 0");
    (values.lease_length && values.lease_length <= 0) && (errors.lease_length = 'Must be greater than 0');

    return errors;
};

EditListingForm = reduxForm({
    form: 'editListingForm',
    validate
})(EditListingForm);

const mapStateToProps = (state, props) => {
    const property = state.owner.properties.find((property) => {
        return property.id === props.propId;
    });
    const listing = property.active_listing;

    return {
        display_address: PolyUtil.getPropertyStreetAddress(property),
        city: PolyUtil.getPropertyCity(property),
        state: PolyUtil.getPropertyState(property),
        listingId: listing.id,
        initialValues: listing,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        _handleEditListing(data, propId, listingId) {
            return dispatch(handleEditListing({
                description: data.description,
                lease_start: data.lease_start,
                lease_length: data.lease_length,
                security_deposit: data.security_deposit,
                rent: data.rent,
                public: data.public
            }, propId, listingId, data.apply_key))
                .then(() => {
                    return dispatch(hideModal('edit_listing_modal_' + props.propId));
                });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditListingForm);



// WEBPACK FOOTER //
// ./src/containers/owner/listings/EditListingForm.js